import { Component, OnInit, Inject, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { IMAGE_URL } from 'app/constants';


@Component({
    selector: 'app-product-popup',
    templateUrl: './Product-Popup.component.html',
    styleUrls: ['./Product-Popup.component.scss'],
    encapsulation: ViewEncapsulation.None
    
})
export class productPopupComponent implements OnInit {
    IMAGE_URL = IMAGE_URL;
    customersForm: FormGroup;
    dialogTitle: string;
    action: string;
    userDetails: any;
    customerType: string;
    item: any;
    constructor(
        public matDialogRef: MatDialogRef<productPopupComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any
    ) {  // Set the defaults
        this.action = _data.action;
        // Set the private defaults
            this.dialogTitle = this._data.item.Description;
            this.item = this._data.item;
    }

    ngOnInit() {
        window.scrollTo(0, 0);
    }

}